import * as types from "../../actionTypes";
import { mastermedicine } from "./medicinemaster";
import { client } from "../../../utils/axios";

const medicineDeactivateLoading = () => ({
  type: types.MEDICINE_DEACTIVATE_LOADING,
});

const medicineDeactivateSuccess = (data) => ({
  type: types.MEDICINE_DEACTIVATE_SUCCESS,
  payload: data,
});
const medicineDeactivateFail = (error) => ({
  type: types.MEDICINE_DEACTIVATE_FAIL,
  payload: error,
});

export const medicinedeactivate = (data) => {
  console.log("api call", data);
  return function (dispatch) {
    dispatch(medicineDeactivateLoading());
    client
      .post(
        `/admin/medicine-deactivate`,
        data
        // {
        //   headers: { Authorization: `Bearer ${secure_token}` },
        // }
      )
      .then((resp) => {
        dispatch(medicineDeactivateSuccess(resp.data));
        console.log("medicine deactivate data", resp.data);
        dispatch(mastermedicine("search%5Bvalue%5D=&start=0&length=100"));
      })
      .catch((error) => {
        console.log("error from medicinedeactivate", error.response);
        dispatch(medicineDeactivateFail(error));
      });
  };
};
